// extracted by mini-css-extract-plugin
export default {"layout":"Home_layout__JCS+N","sidebar":"Home_sidebar__XCZp4","main":"Home_main__dweVa"};